import { render, staticRenderFns } from "./configurationThird.vue?vue&type=template&id=7c853978&scoped=true&"
import script from "./configurationThird.vue?vue&type=script&lang=js&"
export * from "./configurationThird.vue?vue&type=script&lang=js&"
import style0 from "./configurationThird.vue?vue&type=style&index=0&id=7c853978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c853978",
  null
  
)

export default component.exports